import { render } from "./DashboardInner.vue?vue&type=template&id=04b7ee3c&scoped=true"
import script from "./DashboardInner.vue?vue&type=script&lang=js"
export * from "./DashboardInner.vue?vue&type=script&lang=js"

import "./DashboardInner.vue?vue&type=style&index=0&id=04b7ee3c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b7ee3c"]])

export default __exports__